import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CompaniesGenerateContract",
    title: "Генерирование договора",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitGenerate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "В лице Генерального директора Иванова А.А.",
        value: _ctx.state.fullname_initials,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.fullname_initials) = $event)),
        "is-invalid": _ctx.state_form$.fullname_initials.$error,
        "validation-errors": _ctx.state_form$.fullname_initials.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        value: _ctx.state.base,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.base) = $event)),
        placeholder: "Выберите основание",
        "is-invalid": _ctx.state_form$.base.$error,
        "validation-errors": _ctx.state_form$.base.$errors,
        loading: _ctx.bases_state.is_loading,
        options: _ctx.bases_state.list,
        failed: _ctx.bases_state.is_failed,
        "error-text": "При получении списка оснований произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        onRefresh: _ctx.loadBases
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}